import React from "react";
import { createRoot } from "react-dom/client";
import { initSentry } from "@finitless/shared/config";
import "./index.css";
import "./i18n";
import App from "./App.jsx";
import { isWhiteLabel, getWhiteLabelConfigValue } from "@finitless/shared/lib";
import { initWhiteLabel } from "./lib/initWhiteLabel";

// Initialize Sentry as early as possible
initSentry();

// Hydrate apiStore from window.__CONFIG__
initWhiteLabel();

if (isWhiteLabel()) {
  const favicon = getWhiteLabelConfigValue("dashboard_favicon");
  const faviconLink = document.querySelector("link[rel~='icon']");
  if (favicon) {
    const link = faviconLink || document.createElement("link");
    link.rel = "icon";
    link.href = favicon;
    if (!faviconLink) document.head.appendChild(link);
  } else if (faviconLink) {
    faviconLink.remove();
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
